// extracted by mini-css-extract-plugin
module.exports = {"container":"UntrackableCohortMessage_container__1AHoW","icon":"UntrackableCohortMessage_icon__Z8mAO","message":"UntrackableCohortMessage_message__2MR6Z"};